import React from 'react';
import ReactTable from 'react-table';
import { connect } from 'react-redux';
import { Col, Row } from 'react-bootstrap';
import columns from './table-columns';
import { performanceMetricsEnum } from '../../enums';
import { getPerformanceMetrics } from '../../actions/progressActions';
import { GFInitialState, GFPerformanceMetrics, GFTeacherUser } from '../../models/models';

type OwnProps = {
  teacher: GFTeacherUser|undefined;
}

type Props = {
  loading: boolean;
  data: GFPerformanceMetrics[];
  getPerformanceMetrics: typeof getPerformanceMetrics;
}

class Table extends React.Component<OwnProps & Props> {
  componentDidMount() {
    this.loadData();
  }

  componentDidUpdate(prevProps: OwnProps) {
    if (this.props.teacher?.id !== prevProps.teacher?.id) {
      this.loadData();
    }
  }

  loadData = () => {
    const { data, getPerformanceMetrics, teacher } = this.props;

    ! data.length && getPerformanceMetrics(teacher?.id);
  }

  render() {
    const { data, teacher, loading } = this.props;

    const rows = Object.values(data.reduce((result, metric: GFPerformanceMetrics) => {
      // @ts-ignore
      const current = result[metric.id] || {};
      current['id'] = metric.id;
      current['name'] = metric.className;
      current[`quiz.${metric.quizType}.${metric.quizPosition}`] = metric.score;

      return { ...result, [metric.id]: current };
    }, {}));

    return <Row className="class-table" style={{ marginTop: teacher ? '0px' : '15px' }}>
      <Col xs={12}>
        <ReactTable
          className="teacher-class-report -highlight"
          data={rows}
          columns={columns}
          showPagination={false}
          showPageSizeOptions={false}
          pageSize={rows.length}
          key={teacher?.id || 'self'}
          loading={loading}
          noDataText="No progress found."
          resizable={false}
          sortable={false}
          getTrProps={() => ({
            style: {
              cursor: 'default',
            },
          })}
          getTdProps={(state: any, rowInfo: any, column: any) => {
            const score = rowInfo.original[column.id];

            if (typeof score === 'string') return { className: 'no-score' };
            if (score >= 80 && score <= 100) return { className: 'green' };
            if (score >= 51 && score <= 79) return { className: 'yellow' };
            if (score >= 0 && score <= 50) return { className: 'red' };
            return { className: 'no-score' };
          }}
        />
      </Col>
    </Row>;
  }
};

const mapStateToProps = (state: GFInitialState, ownProps: OwnProps) => {
  return {
    loading: state.ajaxCallsInProgress > 0,
    data: state.performanceMetrics[ownProps.teacher?.id || performanceMetricsEnum.self] || [],
  };
};

export default connect(mapStateToProps, {
  getPerformanceMetrics,
})(Table);
